export const validators =  {
  required: {
    regex: '',
    message: 'Campo obrigatório',
    getValue: (value) => value,
    validate: (value) => value.length >= 2,
  },
  cep: {
    regex: /^[0-9]{5}-?[0-9]{3}$/,
    message: 'Cep invalido!',
    getValue: (value) => value.replace(/\D/g,''),
    validate: function (value) {return this.regex.test(value)}
  },
  dinheiro: {
    regex: /^[0-9]{5}-?[0-9]{3}$/, // remove tudo exceto números,
    message: 'Valor deve ser maior que zero!',
    getValue: (value) => Number(value.replace(/\D/g,'')),
    validate: function (value, required) {
      const newValue = value.replace(/\D/g,'')
      if (newValue <= 0 && required) {
        return false
      }
      if (required) return true
      return null
    }
  },
  telefone: {
    regex: /^\(?\d{2}\)?[-.\s]?\d{4,5}[-.\s]?\d{4}$/, 
    message: 'Formato de telefone errado',
    getValue: (value) => value,
    validate: function (value) {
      const phoneRegex = /^\(?\d{2}\)?[-.\s]?\d{4,5}[-.\s]?\d{4}$/ // expressão regular para validate números de telefone
      const onlyNumbers = value.replace(/[^\d]/g, '') // remove todos os caracteres que não são dígitos
      
      if (!phoneRegex.test(onlyNumbers)) { // verifica se a string não corresponde ao formato válido de telefone
        return false
      }            
      return true
    }
  },
  cpfOrCnpj: {
    message: 'Dados de CPF/CNPJ invalidos',
    getValue: (value) => value.replace(/\D/g,''),
    validate: function (value) {
      const cpfRegex = /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}-?[0-9]{2})$/ // expressão regular para validate CPFs
      const cnpjRegex = /^([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}-?[0-9]{2})$/ // expressão regular para validate CNPJs
      const onlyNumbers = value.replace(/[^\d]/g, '') // remove todos os caracteres que não são dígitos
      
      if (onlyNumbers.length === 11) { // verifica se é CPF
        if (!cpfRegex.test(value)) {
          return false
        }
      } else if (onlyNumbers.length === 14) { // verifica se é CNPJ
        if (!cnpjRegex.test(value)) {
          return false
        }
      } else { // se não tem 11 ou 14 dígitos, não é válido
        return false
      }
      
      return true // se chegou até aqui, é válido
    }
  },
  matricula: {
    message: 'A matricula deve conter 32 dígitos',
    getValue: (value) => value.replace(/\s/g, ''),
    validate: function (value) {
      const onlyNumbers = value.replace(/[^\d]/g, '') // remove todos os caracteres que não são dígitos
      if (onlyNumbers.length === 32) return true
      return false
    }
  },
  email: {
    regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: 'Formato de email invalido',
    getValue: (value) => value,
    validate: function (value) {            
      if (this.regex.test(value)) { // Testa o email usando o padrão
        return true
      }
      return false
    }
  },
  pedidoCRC: {
    regex: /^[0-9]{5}(-[0-9]{3})?$/
    ,message: 'Valor deve ser maior que zero!',
    getValue: (value) => String(value.replace(/[^\w\s]/gi,'')),
    validate: function (value, required) {
      const newValue = value.replace(/\D/g,'')
      if (newValue <= 0 && required) {
        return false
      }
      if (required) return true
      return null
    }
  },
  selo: {
    message: 'O selo deve conter 32 dígitos',
    getValue: (value) => value.replace(/\s/g, ''),
    validate: function (value) {
      const onlyNumbers = value.replace(/[^\d]/g, '') // remove todos os caracteres que não são dígitos
      if (onlyNumbers.length === 32) return true
      return false
    }
  },
}

export function ValidateMask (valor) {
  // verifica dinamicamente o tipo de mascara e retorna o valor
  switch (valor) {
    case 'cep':
      return '99999-999'
    case 'cpf':
      return ['999.999.999-99', '99.999.999/9999-99']
    case 'telefone':
      return '(99) 99999-9999'
    case 'matricula':
      return '999999 99 99 9999 9 99999 999 9999999 99'     
      case 'pedidoCRC':
        return '999999-999999999'    
    case 'selo':
          return '999999-9-999-##-99999999999999999999'  
    default:
      return ''
  }
}

